// views/Presentations.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../api/axios";
import Table from "../../components/Table";
import ActionButtons from "../../components/ActionButtons";
import { Plus } from "lucide-react";
import { toast } from "react-toastify";
import SearchBar from "../../components/SearchBar";
import LoadingOverlay from "../../components/LoadingOverlay";
import Pagination from "../../components/Pagination";



function Presentations() {
  const [presentations, setPresentations] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const ITEMS_PER_PAGE = 50;
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    fetchPresentations();
  }, []);

  useEffect(() => {
    setCurrentPage(0);
  }, [searchTerm]);


  const fetchPresentations = async () => {
    try {
      setLoading(true);
      const res = await api.get("/presentations");
      setPresentations(res.data || []);
    } catch (error) {
      toast.error("Error al cargar Presentaciones", "error");
    } finally {
      setLoading(false);
    }
  };

  // Filtrar presentaciones por nombre o descripción
  const filteredPresentations = presentations.filter((presentation) =>
    `${presentation.name} ${presentation.description}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const pageCount = Math.ceil(filteredPresentations.length / ITEMS_PER_PAGE);

  const currentItems = filteredPresentations.slice(
    currentPage * ITEMS_PER_PAGE,
    (currentPage + 1) * ITEMS_PER_PAGE
  );


  return (
    <div className="bg-white p-6 rounded-xl shadow-md relative">
      <LoadingOverlay loading={loading} />

      <div className="flex flex-wrap items-center justify-between mb-6 gap-4">
        <h2 className="text-3xl font-semibold text-gray-800">Presentaciones</h2>

        <div className="flex gap-3 items-center">
          <SearchBar
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Link
            to="/presentations/create"
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg shadow flex items-center gap-2 transition duration-300 whitespace-nowrap"
          >
            <Plus size={18} />
            <span>Nueva Presentación</span>
          </Link>
        </div>
      </div>

      <Table
        columns={[
          { label: "Nombre", key: "name", width: "w-1/2" },
          { label: "Descripción", key: "description", width: "w-1/2" },
        ]}
        data={currentItems}
        renderActions={(presentation) => (
          <ActionButtons
            editUrl={`/presentations/edit/${presentation.id}`}
            onDelete={() => presentation.id}
          />
          
        )}
      />
      {pageCount > 1 && (
  <Pagination
    pageCount={pageCount}
    currentPage={currentPage}
    onPageChange={setCurrentPage}
    currentItemsCount={currentItems.length}
    totalItemsCount={filteredPresentations.length}
  />
)}

    </div>
  );
}

export default Presentations;
